<template>
  <div class="static-page">
    <HeadNav selectedLanguage="en" page="disclaimer" />
    <Breadcrumbs :items="[{ name: 'Disclaimer' }]" />

    <main class="static-content">
      <h1>Disclaimer</h1>

      <p>The information provided on this website is for general informational and educational purposes only.</p>

      <p>This website is an independent resource and is <strong>not the official website of GB WhatsApp or WhatsApp LLC</strong>. We are not the developer, publisher, or owner of GB WhatsApp, nor are we affiliated with or endorsed by WhatsApp LLC.</p>

      <p>All trademarks, product names, logos, and copyrights mentioned on this website belong to their respective owners.</p>

      <p>While we make every effort to keep the information accurate and up to date, we do not guarantee the completeness, reliability, or availability of any content or software referenced on this website.</p>

      <p>Downloading and using third-party applications may involve compatibility, security, or account-related risks. Users are responsible for evaluating these risks and complying with the laws and terms of service applicable in their region.</p>

      <p>Our website may contain links to external websites for additional information or resources. We are not responsible for the content, availability, or privacy practices of third-party websites.</p>

      <p>By using this website, you acknowledge that you do so at your own discretion and risk.</p>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Disclaimer',
  components: {
    HeadNav,
    Breadcrumbs
  }
};
</script>

<style lang="scss" scoped>
.static-content {
  width: 80%;
  max-width: 980px;
  margin: 28px auto 96px;
  color: #121212;
  line-height: 1.7;
}

h1 {
  margin: 0 0 24px;
}

p {
  margin: 0 0 16px;
}

@media (max-width: 768px) {
  .static-content {
    width: 88%;
    margin-bottom: 112px;
  }
}
</style>
